import * as React from 'react';
import { observer } from 'mobx-react';
import { useMemo, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FIRST_STEP, IStepControl } from '../../../domains/wizard';
import { useStore } from '../../../store';
import { DownloadButton } from '../review/download-button';

export interface Props {
  stepControl: IStepControl;
}

export const StepFooter = observer(({ stepControl }: Props) => {
  const { t } = useTranslation('', { keyPrefix: 'BUTTON' });
  const { activeStepIndex, setActiveStep, lastStepIndex } = stepControl;
  const { signUpStore } = useStore();
  const [isClicked, setIsClicked] = useState(false);

  const nextStep = () => {
    setIsClicked(true);
    setActiveStep(activeStepIndex + 1).finally(() => setIsClicked(false));
  };
  const prevStep = () => activeStepIndex > FIRST_STEP && setActiveStep(activeStepIndex - 1);

  const isLast = useMemo(() => activeStepIndex === lastStepIndex, [activeStepIndex, lastStepIndex]);
  const isFirst = useMemo(() => activeStepIndex === FIRST_STEP, [activeStepIndex]);
  const isLoading = isClicked && signUpStore.isLoading;

  return (
    <div className={classNames('container-buttons', isFirst && 'right')} data-html2canvas-ignore="true">
      {!isFirst && (
        <button type="button" className="n2pc-btn-secondary" onClick={prevStep}>
          {t('BACK')}
        </button>
      )}

      <div>
        {isLast && <DownloadButton />}
        <button type="button" className={classNames('n2pc-btn-primary', isLoading && 'loading')} onClick={nextStep} disabled={isLoading}>
          {isLast ? t('SIGN_UP') : t('NEXT')}
        </button>
      </div>
    </div>
  );
});
